"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var PlayerError_1 = __importDefault(require("../utils/PlayerError"));

var withTheme_1 = __importDefault(require("../utils/withTheme"));

var ErrorBoundary =
/** @class */
function (_super) {
  __extends(ErrorBoundary, _super);

  function ErrorBoundary(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      error: null,
      errorInfo: null
    };
    return _this;
  }

  ErrorBoundary.prototype.getChildContext = function () {
    var _this = this;

    return {
      /*
       This is needed to safe throw errors in asynchronous functional components
        @example
       const BuggyComponent = (props, context) => (
           <button onClick=(() => {
              context.throwError(new Error('This will be catched in ErrorBoundary'));
           })>
              Throw an error
          </Button>
       )
      */
      throwError: function throwError(error, errorInfo) {
        if (errorInfo === void 0) {
          errorInfo = null;
        }

        return _this.setState({
          error: error,
          errorInfo: errorInfo
        });
      }
    };
  };

  ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  };

  ErrorBoundary.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _a = this.state,
        error = _a.error,
        errorInfo = _a.errorInfo;

    if (error && error !== prevState.error) {
      if (this.context.errorReporter) {
        this.context.errorReporter.captureException(error, {
          extra: errorInfo
        });
      }

      if (this._hasFatalError() && this.props.onFatalError) {
        this.props.onFatalError(error);
      }
    }
  };

  ErrorBoundary.prototype.render = function () {
    var _this = this;

    if (this._hasFatalError()) {
      return withTheme_1["default"](this.context.theme, 'error')(React.createElement("div", {
        className: this.props.className
      }, withTheme_1["default"](this.context.theme, 'error__message')(React.createElement("div", null, withTheme_1["default"](this.context.theme, 'error__icon')(React.createElement("span", null)), withTheme_1["default"](this.context.theme, 'error__header')(React.createElement("h1", null, "Kunde inte starta uppspelningen")), this.props.externalLinks && withTheme_1["default"](this.context.theme, 'error__text')(React.createElement("p", null, withTheme_1["default"](this.context.theme, 'error__link')(React.createElement("a", {
        href: "https://kontakt.svt.se/guide/uppspelningsproblem"
      }, "F\xE5 hj\xE4lp med uppspelningen"))))))));
    } // We can't return an array of children here because preact has no support for that yet.
    // https://github.com/developit/preact/issues/946


    return React.Children.map(this.props.children, function (child) {
      if (child && React.isValidElement(child)) {
        return React.cloneElement(child, {
          className: _this.props.className,
          style: _this.props.style
        });
      }

      return child;
    })[0];
  };

  ErrorBoundary.prototype._hasFatalError = function () {
    var _a = this.state,
        error = _a.error,
        errorInfo = _a.errorInfo;
    return error && error instanceof PlayerError_1["default"] && error.fatal || errorInfo;
  };

  ErrorBoundary.contextTypes = {
    theme: PropTypes.object,
    errorReporter: PropTypes.object
  };
  ErrorBoundary.childContextTypes = {
    throwError: PropTypes.func
  };
  return ErrorBoundary;
}(React.Component);

exports["default"] = ErrorBoundary;